import { z } from 'zod';
import { requiredString } from '../helpers';
const KbSelectionValidator = z.object({
    kbId: requiredString('Knowledge base ID is required'),
    kbVersionId: requiredString('Version ID is required'),
    fileIds: z.array(requiredString('File ID is required')).min(1, 'At least one file must be selected')
});
export const Knowledge_Base_Query_1_ConfigValidator = z.object({
    knowledgeBases: z.array(KbSelectionValidator).min(1, 'At least one knowledge base must be configured'),
    query: z.string().optional(),
    threshold: z.number().min(0).max(1).optional().default(0),
    maxFiles: z.number().min(1).max(10).optional().default(5)
});
//# sourceMappingURL=knowledge-base-query-1.js.map